(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8866],{

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 84623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65822);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78409);
/* harmony import */ var _utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3265);
/* harmony import */ var _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90017);










const NeedGuidance = ({ classname , button2Data  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const applyCtaButtonProps1 = (0,_utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__/* .getOnboardingOrFormCtaProps */ .J)(router, {
        btnLink: button2Data?.link,
        formId: button2Data?.formId,
        toOnboardingEnabled: button2Data?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,_utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__/* .persistSourceContext */ .jW)({
                    sourceUrl: window.location.href,
                    primarySource: _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__/* .PRIMARY_SOURCE_B2C_WIDGET */ .ov,
                    fifthStepVisible: button2Data?.nearestOffice ?? true,
                    coachingVisible: button2Data?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "need-guidance",
            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            fontSize: "26px"
                                        },
                                        children: "Need guidance? Let us help you."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/contact-us",
                                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btTranparent),
                                            children: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: `${(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().enquireBtn)} ${classname || ""} ${applyCtaButtonProps1.formClassName}`,
                                            onClick: button2Data ? ctaBtnClickHandler(applyCtaButtonProps1) : undefined,
                                            children: button2Data?.title ?? "Enquire Now"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NeedGuidance);


/***/ }),

/***/ 83172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60558);
/* harmony import */ var _components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78182);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35005);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26699);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var _NeedGuidance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84623);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40607);















const PartnerWebinars = (props)=>{
    const { 0: filters , 1: setFilters  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        city: "",
        studydestination: "",
        eventType: "",
        searchValue: ""
    });
    const { 0: searchKeyword , 1: setSearchKeyword  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { 0: searchQuery , 1: setSearchQuery  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const { 0: allWebinars , 1: setAllWebinars  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: totalCount , 1: setTotalCount  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const { searchValue  } = filters;
    const { 0: isViewMore , 1: setIsViewMore  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const debounceSearchQuery = (searchKeyValue)=>{
        const search = lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default()(()=>setFilters({
                ...filters,
                searchValue: searchKeyValue
            }), 500);
        setSearchQuery((prevSearch)=>{
            if (prevSearch.cancel) {
                prevSearch.cancel();
            }
            return search;
        });
        search();
    };
    const routeCoundition = router.pathname.includes("university");
    const webinartype = routeCoundition ? "webinar_by_university_delegate" : "webinar_by_kc_expert";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const search = searchValue ? `&name_contains=${searchValue}` : "";
        const limitCondition = isViewMore ? "" : "&_limit=6";
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/partner-webinars?webinarType=${webinartype}&_sort=startDate:ASC&_start=0${search}${limitCondition}`, "GET", {}, "", false).then((res)=>{
            setAllWebinars(res);
        });
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/partner-webinars/count?webinarType=${webinartype}&_start=0${search}${limitCondition}`, "GET", {}, "", false).then((res)=>{
            setTotalCount(res);
        });
    }, [
        filters,
        isViewMore
    ]);
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "part-edtech",
                className: `${(_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().edtech)} ${(_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().bgColor)}`,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().breadcrum),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                lg: 12,
                                md: 12,
                                xs: 12,
                                className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().centered),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Item */ .Z.Item, {
                                            style: {
                                                opacity: 0.5,
                                                color: "#313145"
                                            },
                                            href: "/",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Item */ .Z.Item, {
                                            style: {
                                                color: "#313145"
                                            },
                                            href: "",
                                            children: " Partner Webinars "
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                id: "event-week-edtech",
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().theEventweek),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().titleClass),
                            children: " All Our Partner Webinars "
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().filtersDrop),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    lg: 9,
                                    md: 9,
                                    xs: 12,
                                    className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().filtercheck)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    lg: 3,
                                    md: 3,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                        className: "navbar-form",
                                        role: "search",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "input-group add-on",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputBox),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        className: "form-control",
                                                        placeholder: "Search Webinars",
                                                        name: "srch-term",
                                                        id: "srch-term",
                                                        type: "text",
                                                        value: searchKeyword,
                                                        onChange: (e)=>{
                                                            const searchValues = e.target.value;
                                                            debounceSearchQuery(searchValues);
                                                            setSearchKeyword(searchValues);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputBtn),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                            src: "/searchco.svg",
                                                            alt: "searchco",
                                                            width: 14,
                                                            height: 14
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: `${(_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().eventTabs)} nav nav-tabs`,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "nav-item",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: ()=>router.push("/partners/webinar-by-university-delegates"),
                                        type: "button",
                                        className: `nav-link ${routeCoundition ? "active" : ""}`,
                                        children: "Webinars by University"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "nav-item",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: ()=>router.push("/partners/webinar-by-kc-admission-experts"),
                                        type: "button",
                                        className: `nav-link ${routeCoundition ? "" : "active"}`,
                                        children: "Webinars by KC"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "d-none d-sm-block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().theEventweek),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                children: allWebinars?.length > 0 ? allWebinars.map((event)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        xs: 12,
                                        md: 4,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardCust),
                                            style: {
                                                height: "350px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Img */ .Z.Img, {
                                                    variant: "top",
                                                    src: event.imageUrl
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Body */ .Z.Body, {
                                                    className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardBody),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Text */ .Z.Text, {
                                                            className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().textDate),
                                                            children: [
                                                                event.date,
                                                                " \xb7 ",
                                                                event.time
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Title */ .Z.Title, {
                                                            className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().subTitle),
                                                            children: event.name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                            size: "lg",
                                                            className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btEduExpo),
                                                            onClick: ()=>router.push(event.registerUrl),
                                                            children: "Register Now"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, event.id);
                                }) : "No Webinars"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "d-block d-sm-none",
                        children: allWebinars.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().theEventweek),
                            children: allWebinars.map((event)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    ...settings,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                xs: 12,
                                                md: 4,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardCust),
                                                    style: {
                                                        height: "350px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Img */ .Z.Img, {
                                                            variant: "top",
                                                            src: event.imageUrl
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Body */ .Z.Body, {
                                                            className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardBody),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Text */ .Z.Text, {
                                                                    className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().textDate),
                                                                    children: [
                                                                        event.date,
                                                                        " \xb7 ",
                                                                        event.time
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Title */ .Z.Title, {
                                                                    className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().subTitle),
                                                                    children: event.name
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                                    size: "lg",
                                                                    className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btEduExpo),
                                                                    onClick: ()=>router.push(event.registerUrl),
                                                                    children: "Register Now"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, event.id)
                                });
                            })
                        }) : "No Webinars"
                    }),
                    totalCount > 6 && !isViewMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().viewMoreContainer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                onClick: ()=>setIsViewMore(true),
                                className: (_components_UpcomingEvents_UpcomingEvents_module_scss__WEBPACK_IMPORTED_MODULE_8___default().viewMore),
                                children: " See More "
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NeedGuidance__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PartnerWebinars);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 60558:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"abttopContent":"UpcomingEvents_abttopContent__8_Cqm","btEduExpoAlign":"UpcomingEvents_btEduExpoAlign__r4jRr","btEduExpo":"UpcomingEvents_btEduExpo__uSk_h","abttopContentdesk":"UpcomingEvents_abttopContentdesk__4DRX_","centerContent":"UpcomingEvents_centerContent__dvBF5","edtech":"UpcomingEvents_edtech__fjg7n","bgColor":"UpcomingEvents_bgColor__xgRwv","breadcrum":"UpcomingEvents_breadcrum__jbHmP","enquirebtn":"UpcomingEvents_enquirebtn__zjJkV","heading":"UpcomingEvents_heading__ZnCl8","buttongp":"UpcomingEvents_buttongp__3E1Bq","kcbtn":"UpcomingEvents_kcbtn__LHQpf","centered":"UpcomingEvents_centered__iAPwJ","eduExpoBox":"UpcomingEvents_eduExpoBox__zy4ht","breadcrumb-item":"UpcomingEvents_breadcrumb-item__v5_PK","active":"UpcomingEvents_active__0fxRu","hideimg":"UpcomingEvents_hideimg__Sc_dI","rowPadding":"UpcomingEvents_rowPadding__y4jPW","viewMoreContainer":"UpcomingEvents_viewMoreContainer__q4cNo","viewMore":"UpcomingEvents_viewMore__lOSeT","learnText":"UpcomingEvents_learnText__Vr50O","iconSetting":"UpcomingEvents_iconSetting__pC0En","theEventweek":"UpcomingEvents_theEventweek__vmHHo","textDate":"UpcomingEvents_textDate__eoPkZ","subTitle":"UpcomingEvents_subTitle__GNXd_","descripEvent":"UpcomingEvents_descripEvent__vu5nx","smallText":"UpcomingEvents_smallText__iJQTM","cardCust":"UpcomingEvents_cardCust__nyKHs","cardBody":"UpcomingEvents_cardBody__uMJY1","card-img":"UpcomingEvents_card-img__LTmtQ","card-img-bottom":"UpcomingEvents_card-img-bottom__to1l5","card-img-top":"UpcomingEvents_card-img-top__DLVhH","eventTabs":"UpcomingEvents_eventTabs__Ede2L","inputBox":"UpcomingEvents_inputBox__dRGBn","inputBtn":"UpcomingEvents_inputBtn__my_x0","filtersDrop":"UpcomingEvents_filtersDrop__XkKhQ","filtercheck":"UpcomingEvents_filtercheck__BBnDo","selectdiv":"UpcomingEvents_selectdiv__Pf5jW","Selectfilt":"UpcomingEvents_Selectfilt__oWxuW","activeSelect":"UpcomingEvents_activeSelect__ZRVvC","filterSelect":"UpcomingEvents_filterSelect__1PKpc","mobilemenu":"UpcomingEvents_mobilemenu__xAQYx","btn":"UpcomingEvents_btn___nusr","menu":"UpcomingEvents_menu__asLuI","modal-footer":"UpcomingEvents_modal-footer__oiTSK","filtCat":"UpcomingEvents_filtCat__o6vJI","footerSpace":"UpcomingEvents_footerSpace__6Mypb","btnsecondary":"UpcomingEvents_btnsecondary__NxzAQ","btnprimary":"UpcomingEvents_btnprimary__Jp15R","contain":"UpcomingEvents_contain__krwNI","catfilter":"UpcomingEvents_catfilter__Ik3Va","catSelected":"UpcomingEvents_catSelected__VeDzY","optfilter":"UpcomingEvents_optfilter__hOEqg","optselfilter":"UpcomingEvents_optselfilter__YAX2p","sliderDots":"UpcomingEvents_sliderDots__XhxBQ","mainTitle":"UpcomingEvents_mainTitle__Zal4Q","titleClass":"UpcomingEvents_titleClass__BIkV1","clearFilter":"UpcomingEvents_clearFilter__PVLcj"};

/***/ }),

/***/ 65822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentFooter":"NeedGuidance_studentFooter__5o74_","session":"NeedGuidance_session__8Zc7c","anchor":"NeedGuidance_anchor__9XZiq","enquireBtn":"NeedGuidance_enquireBtn__u9ZDM","btTranparent":"NeedGuidance_btTranparent__iNGT9"};

/***/ })

}]);